import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../state';
import { Header } from './Header';

const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setTabIsDefault: (newValue: boolean) =>
    dispatch.connections.setTabIsDefault(newValue),
});

const mapState = (state: RematchRootState<RootModel>) => ({
  connectionId: state.connections.connection?.id,
  project: state.projects.project,
  serviceName: state.services.service?.displayName,
  tabIsDefault: state.connections.tabIsDefault,
});

export const ConnectedHeader = connect(mapState, mapDispatch)(Header);
